
    import React from 'react';
    import SpriteSymbol from "svg-baker-runtime/browser-symbol";
    import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
    import SpriteSymbolComponent from "../../components/Icon/Icon.js";

    const symbol = new SpriteSymbol({
  "id": "arrow-right-filled.icon",
  "use": "arrow-right-filled.icon-usage",
  "viewBox": "0 0 11 19",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 11 19\" id=\"arrow-right-filled.icon\"><path fill-rule=\"evenodd\" d=\"M10.16 9.49L.13 18.994V.13l10.03 9.36z\" /></symbol>"
});
    sprite.add(symbol);
    export default class ArrowRightFilledIconSpriteSymbolComponent extends React.Component {
      render() {
        return <SpriteSymbolComponent glyph="arrow-right-filled.icon" {...this.props} />;
      }
    }
  


// WEBPACK FOOTER //
// ./src/media/icons/arrow-right-filled.icon.svg